import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const STANDINGS_SCOPE_DROPDOWN_WIDTH = 168

export const getLeagueStandingsScopePickerStyles = (theme: Theme) => ({
  ...StyleSheet.create({
    triggerWrap: {
      flexShrink: 0,
      alignSelf: 'center',
    },
    staticPill: {
      flexDirection: 'row',
      alignItems: 'center',
      flexShrink: 0,
      backgroundColor: theme.background.card,
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: 999,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[200],
      gap: 5,
      ...(Platform.OS === 'web'
        ? { boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)' as const }
        : {
            shadowColor: theme.black,
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.08,
            shadowRadius: 3,
            elevation: 1,
          }),
    },
    staticPillText: {
      fontSize: 12,
      lineHeight: 16,
      fontWeight: '600',
      letterSpacing: 0.2,
      color: theme.gray[700],
      ...(Platform.OS === 'android' ? { includeFontPadding: false } : {}),
    },
    dropdown: {
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 999,
      paddingHorizontal: 12,
      height: 30,
      minWidth: 104,
      backgroundColor: theme.background.card,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[200],
    },
    dropdownOverlayContainer: {
      zIndex: 1000,
      width: STANDINGS_SCOPE_DROPDOWN_WIDTH,
      minWidth: STANDINGS_SCOPE_DROPDOWN_WIDTH,
      backgroundColor: theme.background.card,
      borderWidth: 1,
      borderColor: theme.gray[200],
      borderRadius: 12,
      marginTop: 6,
    },
    dropdownItemContainer: {
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[200],
      paddingHorizontal: 14,
    },
    dropdownItemText: {
      fontSize: 14,
      color: theme.gray[800],
    },
    placeholderStyle: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[700],
    },
    selectedTextStyle: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[700],
    },
  }),
  dropdownFlatListWeb: {
    maxHeight: 220,
    overflowY: 'scroll' as const,
    WebkitOverflowScrolling: 'touch' as const,
  },
})
